import { IErrorIdentification } from '@App/app/entities/shared/error-identificator.model';

export const buildDeleteModelsDetailMessage = (
  deletableModels: IErrorIdentification[],
  indelibleModels: IErrorIdentification[],
  deletedModels: IErrorIdentification[],
): string => {
  const deletedModelsNames = deletedModels.map((item) => item.name).join(', ');
  const deletableModelsString = deletableModels.map((item) => item.name).join(', ');
  const indelibleModelsString = indelibleModels.map((item) => item.name).join(', ');

  let detailMessage = '';
  if (deletedModels.length) {
    detailMessage += `Models<b> ${deletedModelsNames}</b> are already deleted.\n`;
  }
  if (indelibleModels.length) {
    detailMessage += `Models <b>${indelibleModelsString}</b> cannot be deleted.\n`;
  }
  if (deletableModels.length) {
    detailMessage += `Models <b>${deletableModelsString}</b> have some existing build processes.\n`;
  }
  detailMessage += '\nDo you want to delete them anyway?';
  return detailMessage;
};
